(ns ui.components.chart.view
  (:require
   ["highcharts" :as Highcharts]
   ["highcharts-react-official" :default HighchartsReact]
   ["highcharts/highcharts-more" :as highcharts-more]
   ["highcharts/highmaps" :as highmaps]
   ["highcharts/modules/exporting" :as exporting]
   ["highcharts/modules/map" :as high-map]
   [potpuri.core :as potpuri]))

(defn init-highcharts!
  []
  (high-map Highcharts)
  (exporting Highcharts)
  (highcharts-more Highcharts)
  (exporting highmaps)
)

(defn options
  [{:keys [background-color title height width] :as params}]
  (potpuri/deep-merge {:chart       {:backgroundColor (or background-color "transparent")
                                     :borderRadius    10
                                     :height          height
                                     :width           width}
                       :title       {:text  (or title nil)
                                     :style {:fontSize   "14px"
                                             :fontFamily "Colibri, Agenda, sans-serif"}}
                       :credits     {:enabled false}
                       :legend      {:enabled true}
                       :borderWidth 1
                       :shadow      false
                       :tooltip     {:headerFormat "<b>{point.x}</b><br/>"
                                     :pointFormat  "{series.name}: {point.y}"}}
                      params))

(defn view
  [options constructor-type]
  [:> HighchartsReact
   (merge {:highcharts Highcharts
           :options    options}
          (when constructor-type
            {:constructorType constructor-type}))])
